import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { getSource } from "@/lib/acquisitionSource";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ full_name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await register({ ...form, role: "buyer", acquisition_source: getSource() });
      toast.success(`Welcome, ${u.full_name}`);
      const next = params.get("next");
      nav(next || "/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16" data-testid="register-page">
      <h1 className="font-display text-4xl mb-2">Join CityShor</h1>
      <p className="text-gray-600 mb-8">A new set of curated fashion and lifestyle products goes live every day. Sign up to shop.</p>
      <form onSubmit={submit} className="space-y-4">
        <div><Label>Full Name</Label><Input data-testid="reg-name" required value={form.full_name} onChange={upd("full_name")} /></div>
        <div><Label>Email</Label><Input data-testid="reg-email" type="email" required value={form.email} onChange={upd("email")} /></div>
        <div><Label>Phone</Label><Input data-testid="reg-phone" value={form.phone} onChange={upd("phone")} /></div>
        <div>
          <Label>Password</Label>
          <div className="relative">
            <Input data-testid="reg-password" type={showPassword ? "text" : "password"} required minLength={6} value={form.password} onChange={upd("password")} className="pr-10" />
            <button
              type="button"
              data-testid="reg-password-toggle"
              onClick={() => setShowPassword((v) => !v)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              aria-label={showPassword ? "Hide password" : "Show password"}
              tabIndex={-1}
            >
              {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
        </div>
        <Button data-testid="reg-submit" type="submit" disabled={busy} className="w-full rounded-full h-11 bg-[#F48E2E] hover:bg-[#D97815]">
          {busy ? "Creating…" : "Create Account"}
        </Button>
      </form>
      <div className="mt-6 text-sm text-center text-gray-600">
        Already registered? <Link to={`/login${params.get("next") ? `?next=${params.get("next")}` : ""}`} className="text-[#F48E2E]">Log in</Link>
      </div>
    </div>
  );
}
